var _path, _path2, _circle, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRedeemUn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.524016 15.7384H1.57205C1.86145 15.7384 2.09607 15.5038 2.09607 15.2144V9.4502H0.524016C0.23462 9.4502 0 9.68481 0 9.97421V15.2144C0 15.5037 0.23462 15.7384 0.524016 15.7384Z",
    fill: "#2D81F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C8.79083 0 7 1.79083 7 4C7 6.2091 8.79083 8 11 8C13.2092 8 15 6.2091 15 4C15 1.79083 13.2092 0 11 0Z",
    fill: "#2D81F7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 4,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0002,
    cy: 3.99995,
    r: 2.3,
    fill: "#2D81F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46022 16.0178H9.57551C11.3362 15.9968 13.0235 15.4974 14.5118 14.596L17.4358 12.5523C17.9283 12.2065 18.0226 11.5567 17.6978 11.0956C17.3624 10.6135 16.7126 10.4982 16.241 10.8336L13.4323 12.8039C12.531 13.3279 11.4306 13.4432 10.4349 13.1078L7.20346 12.0387C6.93097 11.9549 6.78421 11.651 6.87857 11.3786C6.96238 11.1165 7.23486 10.9698 7.50735 11.0432C7.51783 11.0432 11.137 12.217 11.137 12.217C11.7465 12.3997 12.288 12.0548 12.4576 11.5462C12.6357 10.9907 12.3318 10.4038 11.7868 10.2257L6.85757 8.61175C5.77943 8.21926 4.32654 8.30034 3.14404 8.96158V14.8278L7.25582 15.7593C8.00905 15.925 8.74812 16.0178 9.46022 16.0178Z",
    fill: "#2D81F7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedeemUn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redeem-un.78e1210e.svg";
export { ForwardRef as ReactComponent };